import { logosAndTextTemplate1Blueprint } from "@made-people/blueprint-logos-and-text/blueprint";

logosAndTextTemplate1Blueprint.override({
  slots: {
    wrapper:
      "flex flex-col w-full md:flex-row gap-6 md:gap-8 lg:gap-16 text-body-sm lg:text-body-md",
    logosWrapper: "md:w-1/2 overflow-hidden",
    logos: "",
    content:
      "flex flex-col gap-4 items-start md:w-1/2 justify-start md:gap-6 lg:gap-8 ",
    text: "",
    link: "",
  },
  variants: {
    layout: {
      vertical: {
        wrapper: "flex flex-col",
      },
      horizontal: {
        wrapper: "flex flex-row",
      },
      "horizontal-reverse": {
        wrapper: "flex flex-row-reverse",
      },
      "vertical-reverse": {
        wrapper: "flex flex-col-reverse",
      },
    },
  },
});
